// blog data

export const Blogs = [
    {
        id:1,
        name:"How I Became A Data Scientist With No Experience: The Story Of How A Unilag Undergraduate Became A Chief Data Scientist In America",
        tags:["data-science","data-scientist","undergraduate"],
        imgSrc:"https://1.bp.blogspot.com/-UpykJcqvAeM/YCPNGNE9m9I/AAAAAAAACBI/jOgj70KgJboWliCoeabW8VM-pOTrwPu9gCLcBGAsYHQ/s1920/Shugaba%2B%25288%2529.png",
        link:"https://dashugaba.blogspot.com/2021/02/how-i-became-data-scientist-with-no.html?fbclid=IwAR197_oID8kBdBlQ41jg3fDBGSWrME3D84G2-Vutfuzfy_iqoHAIOuyjc8s"
    },
    {
        id:2,
        name:"Making Money 24/7 as a Data Scientist without sitting in an office.",
        tags:["money","data-scientist","office"],
        imgSrc:"http://www.paypervids.com/wp-content/uploads/2017/01/11-Ways-to-Make-Money-Online-From-Home.jpeg",
        link:"https://www.linkedin.com/posts/oyelade-david_datascience-work-datascientist-activity-6872455821695954945-yHSx"
    },
    {
        id:3,
        name:"Is Masters in Data Science a prerequisite to excel in the field of Data Science?",
        tags:["masters","data-science","excel"],
        imgSrc:"https://media-exp1.licdn.com/dms/image/C4D22AQHVBhQ33ifFcQ/feedshare-shrink_2048_1536/0/1636446919221?e=1648684800&v=beta&t=1dyU7p2lhzCida8RIU3bMBzOXXin6c-R-VkUwSoISYE",
        link:"https://www.linkedin.com/posts/oyelade-david_datascience-community-linkedin-activity-6863755862725431296-67D9"
    },
    {
        id:4,
        name:"How do I build a result-oriented Data Science team?",
        tags:["result","team","data-science"],
        imgSrc:"https://media-exp1.licdn.com/dms/image/C4D22AQH0aOkAIFDSBw/feedshare-shrink_800/0/1634548351780?e=1648684800&v=beta&t=Ipwrza0jfgM0U9b606H781RBgA8Myv67eon-dBJqZZA",
        link:"https://www.linkedin.com/posts/oyelade-david_datascience-team-collaboration-activity-6855792696267677696-1ah5"
    },
    {
        id:5,
        name:"How did I teach myself Data Science?",
        tags:["teach","data-science","self-development"],
        imgSrc:"https://media-exp1.licdn.com/dms/image/C4D22AQGVEnAzXcSoHg/feedshare-shrink_800/0/1632989081523?e=1648684800&v=beta&t=xfJ1g4f23qeJvFfiNQjft00NGXpUBIhVnhgc_fmL0ts",
        link:"https://www.linkedin.com/posts/oyelade-david_datascience-covid-datascientist-activity-6849252642909102080-1gEw"
    },
    {
        id:6,
        name:"Making giant strides in Data Science!!",
        tags:["data-science","growth"],
        imgSrc:"https://media-exp1.licdn.com/dms/image/C4D22AQHfrSIOSrRCMw/feedshare-shrink_800/0/1626335989831?e=1648684800&v=beta&t=MsvOoGQCKM13kiW6j_Iyxtwnc__g90VgClhK-Q-UpbI",
        link:"https://www.linkedin.com/posts/oyelade-david_datascience-datascientist-career-activity-6821347553829756928-Cnxm"

    },
   

] 